<template>

<app-table-cell class="activity">

	<div class="activity-text" v-html="text" />
	<div class="activity-date">{{ action.date | fromNow }}</div>

</app-table-cell>

</template>

<script>

export default {

	props: ['action'],

	computed: {

        text: function() {
        
            var text = this.action.text 
            var object = []

            text = '<b>' + ((this.action.user) ? this.action.user.name : 'System') + '</b> ' + text.charAt(0).toLowerCase() + text.slice(1)

            object.push('<b>' + this.action.data.name + '</b>')

            text = text.replace('{{object}}', object.join(''))

            text = text.replace('{{type}}', this.$constants.activity.typeName[this.action.type].toLowerCase())

            /*if(this.action.context === this.$constants.activity.context.updated) {

                var changes = this.$_.keys(this.action.data.changes)
            
                text = text + ' with ' + changes.length.toString() + ' change' + ((changes.length === 1) ? '' : 's')

            }*/

            return text
        
        },
	
		subtext: function() {

			var count = this.action.subactivities.length
		
			return count.toString() + ' sub-process' + ((count == 1) ? '' : 'es')
		
		}
	
	}

}

</script>

<style scoped>

.activity {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.activity-text {
	line-height: 16px;
}

.activity-text >>> i {
    font-style: italic;
    opacity: 0.6;
}

.activity-date {
	font-size: 12px;
	opacity: 0.8;
	margin-top: 0px;
}

</style>
